import React, { useState, useEffect } from 'react';
import styles from './TemplateHero3.module.css';

const TemplateHero3 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Same as 1 & 2)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        >
          {/* Subtle Bottom-up gradient for text legibility */}
          <div className={styles.vignetteOverlay}></div>
        </div>
      ))}

      {/* Content Area */}
      <div className={styles.mainWrapper}>
        <div className={styles.contentBox} key={`content-${currentSlide}`}>
          <div className={styles.accentLine}></div>
          
          <span className={styles.slideNumber}>0{currentSlide + 1}</span>
          
          <h1 className={styles.title}>
            {slides[currentSlide].title}
          </h1>
          
          <p className={styles.subtitle}>
            {slides[currentSlide].subtitle}
          </p>

          <div className={styles.ctaWrapper}>
            <button className={styles.mainBtn}>
              Get Started
              <span className={styles.btnArrow}>→</span>
            </button>
            <button className={styles.textBtn}>
              View Details
            </button>
          </div>
        </div>
      </div>

      {/* Progress Bar Indicators (Horizontal Bars) */}
      {slides.length > 1 && (
        <div className={styles.barIndicators}>
          {slides.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={styles.barWrapper}
            >
              <div className={`${styles.bar} ${index === currentSlide ? styles.activeBar : ''}`}></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateHero3;